import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.VUE_APP_ENCRYPT_DECRYPT_SECRET_KEY;

export function decryptData(encryptedData: any) {
  const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
  const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
  return decryptedData;
}
